import { CustomerBalances } from '../../models/sale'
import {
  getAbpOutstandingBalance,
  resolveAbpCappedAmount,
} from '../../constants/abp-balance-type'
import { resolveAbpInitialAmount } from './resolveAbpInitialAmount'

/**
 * Resolves and safely caps URL-prefilled account balance payment (ABP) amount using customer balance.
 *
 * This helper exists to keep the full initialization decision path in one place:
 * 1) derive outstanding debt from the combined account balance,
 * 2) apply existing URL amount parsing/validation,
 * 3) apply final defensive capping against the balance.
 *
 * Keeping this composition in a dedicated function allows unit tests to cover
 * the sale-initialization wiring without mounting the `useSaleInitialising` hook.
 */
export const resolveAbpInitialAmountForBalances = (
  prefilledAmountParam: string | null,
  balances: Pick<CustomerBalances, 'account'>
): number => {
  const outstandingBalance = getAbpOutstandingBalance(balances)

  return resolveAbpCappedAmount(
    resolveAbpInitialAmount(prefilledAmountParam, outstandingBalance),
    balances
  )
}
